export class ComponentOutputStatus<T> {
  status: boolean;
  output: T;

  public static of<K>(status: boolean, output: K): ComponentOutputStatus<K> {
    const componentStatus = new ComponentOutputStatus<K>();
    componentStatus.status = status;
    componentStatus.output = output;
    return componentStatus;
  }

  public ifValid(effect: (value: T) => void) {
    if (status) {
      effect(this.output);
    }
  }

  public each(effect: (value: T) => void) {
    effect(this.output);
  }

  public mapValue<K>(mapper: (value: T) => K) {
    return ComponentOutputStatus.of(this.status, mapper(this.output));
  }
  
}
